import { render, staticRenderFns } from "./InvestorOpportunities.vue?vue&type=template&id=055b92fa&"
import script from "./InvestorOpportunities.vue?vue&type=script&lang=js&"
export * from "./InvestorOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports